__turbopack_context__.v({
  "app_light_theme": "HiddenMenu-module-scss-module__jTW1ZG__app_light_theme",
  "hiddenMenu": "HiddenMenu-module-scss-module__jTW1ZG__hiddenMenu",
});
